module.exports = __webpack_public_path__ + "assets/comment-4194873f0e22893e83fe5eb4631c5d80.svg";